import React from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { NumberFilter } from '../filters/NumberFilter';

export const FloatField: FieldComponent<number, string[]> = ({
  onChange,
  isActive,
  value,
  intent,
  hasTooltip,
}) => {
  return (
    <>
    </>
  );

  /*return <>{value}</>;*/
};

FloatField.includes = (query = [], value = NaN) =>
  query.length === 0 ||
  query.some((filter) => {
    const filterValue = parseFloat(filter);
    if (!isNaN(filterValue)) {
      return filterValue === value;
    }
    return false;
  });

FloatField.comparator = (one, other) => {
  if (other === undefined) return -1;
  if (one === undefined) return 1;
  return one - other;
};

FloatField.FilterRenderer = NumberFilter;
